<script>import { beforeUpdate } from "svelte";
import { fade } from "svelte/transition";
import { quintOut } from "svelte/easing";
import inView from "../_helpers/inView";
import { getPicture, getImage } from "./Picture.utils";
import {
  PlaceholderType
} from "@thisissoon/flitejs-core";
export let imageInput;
export let imageInputConfig;
export let noPlaceholder = false;
export let altText = "";
export let coverImage = false;
export let inViewOptions = {
  rootMargin: "0px",
  threshold: 0
};
export let placeholderConfig = {
  type: PlaceholderType.BLURRED,
  blurredWidth: 40
};
let image;
let picture;
let sources = [];
$:
  if (imageInput) {
    image = getImage(imageInput, imageInputConfig, placeholderConfig, altText);
    picture = getPicture(image);
    sources = [...picture.sources];
    sources.sort((a, b) => b.minWidth - a.minWidth);
  }
let thisImage;
let loaded = false;
let isInViewport = false;
$: {
  loaded = imageInput && false;
}
beforeUpdate(() => {
  if (thisImage) {
    thisImage.onload = () => {
      loaded = true;
    };
  }
});
</script>

<style>
  .inner {
    position: relative;
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }

  .inner.coverImage {
    height: 100%;
  }

  .placeholder--blur > .placeholderImg {
    filter: blur(4px);
  }

  .inner.coverImage .placeholderImg {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  .fullRes {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .inner.coverImage .fullRes {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .inner.noPlaceholder .fullRes {
    position: static;
  }

  .inner.coverImage .fullResImg {
    object-fit: cover;
    height: auto;
    width: 100%;
  }

  img {
    vertical-align: middle;
    width: 100%;
  }
</style>

<div
  class="inner"
  class:noPlaceholder
  class:coverImage
  use:inView={inViewOptions}
  on:intersect={({ detail }) => {
    if (isInViewport && !detail) {
      return;
    }
    isInViewport = detail;
  }}
>
  {#if !noPlaceholder}
    <picture
      class="placeholder {placeholderConfig.type === PlaceholderType.BLURRED
        ? 'placeholder--blur'
        : ''}"
      class:loaded
      transition:fade={{ duration: 1200, easing: quintOut }}
    >
      {#each sources as source}
        <source
          media={`(min-width: ${source.minWidth / 16}rem)`}
          srcSet={source.placeholderUrl}
        />
      {/each}
      <img
        class="placeholderImg"
        alt={picture.altText}
        src={picture.fallback.placeholderUrl}
      />
    </picture>
  {/if}
  {#if isInViewport}
    <picture
      class="fullRes"
      class:loaded
      transition:fade={{ duration: 1200, easing: quintOut }}
    >
      {#each sources as source}
        <source
          media={`(min-width: ${source.minWidth / 16}rem)`}
          srcSet={source.srcSet}
        />
      {/each}
      <img
        class="fullResImg"
        alt={picture.altText}
        src={picture.fallback.src}
        bind:this={thisImage}
      />
    </picture>
  {/if}
</div>
